import { Box, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'

interface Props {
  title: string
  subTitle?: string
  description?: string
  children: React.ReactNode
}

export const Body = ({ title, subTitle, description, children }: Props) => {
  return (
    <Box gap="s12" className={'Body_headerContainer'}>
      <Text.Header1>{title}</Text.Header1>
      {subTitle && <Text.Normal weight="medium">{subTitle}</Text.Normal>}
      {description && <Text.Normal color="textSecondary">{description}</Text.Normal>}

      {children}
    </Box>
  )
}
